import React, { useEffect, useState, useRef } from 'react';
import makeStyles from "@material-ui/styles/makeStyles";
import withStyles from "@material-ui/styles/withStyles";
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { PageHeader } from '../../components';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import api from "../../common/api";
import CircularProgress from "@material-ui/core/CircularProgress";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import {useGlobalState} from '../../state';
import Divider from '@material-ui/core/Divider';
import moment from "moment";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
window.html2canvas = html2canvas;
const useStyles = makeStyles(theme => ({
    divider: {
        backgroundColor: '#101010'
    },
    root: {},
    content: props => ({
        margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    link: {
        display: 'flex',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    formControl: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        minWidth: 160,
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressContainerA:{
        display: 'block',
        position: "absolute",
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        top: '95%',
        left: '55%'
    },
    progressBar: {
        margin: theme.spacing(2)
    },
    singleLineBorder: {
        borderTop: 'solid 1px #F26522',
        borderBottom: 'solid 1px #F26522'
    },
    doubleLineBorder: {
        borderTop: 'double #F26522',
        borderBottom: 'double #F26522'
    },
    boldedText: {
        fontWeight: 'bold'
    },
    reportContainer: {

    },
    reportHeader: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    rawMaterialName: {
        textAlign: 'center',
        textDecoration: 'underline'
    }
}));

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    body: {
        fontSize: '1em',
        backgroundColor: theme.palette.common.white,
        padding: '6px',
        paddingLeft: '16px'
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
}))(TableRow);


const tableHeader = JSON.parse(`[["Customer Name","Bill Balance"]]`);
const tableHeaderForVendor = JSON.parse(`[["Vendor Name","Bill Balance"]]`);


const generateExcel = function (header, data) {
    console.debug("excel ", header, data)
    let csvData = '';
    header.forEach((column, index) => {
        if (index === 0)
            csvData = csvData + column
        else
            csvData = csvData + ',' + column
    });
    csvData = csvData + '\r\n';
    data.forEach(row => {
        Object.values(row).forEach((column, index) => {
            if (index !== 2 && index !== 3 && index !== 4 && index !== 5 ) { // Don't include the customer ID and Total
                if (index === 0)
                    csvData = csvData + column
                else
                    csvData = csvData + ',' + column   
            }
        });
        csvData = csvData + '\r\n';
    });
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData));
    element.setAttribute('download', 'Bill Balance Report.csv');

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

 

const BillBalanceReport = function ({ showError, match }) {
    const theme = useTheme();

    const [startDate, setStartDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [popUploading, setPopUpLoading] = useState(false)
    const [valid, setValid] = useState(false);
    const [data, setData] = useState([]);
    const [invoiceSetting, setInvoiceSetting] = useState({});
    const [{user}] = useGlobalState();
    const [statementType, setStatementType] = useState(1);
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }

    useEffect(() => {
        if (startDate) {
            setValid(true);
        } else {
            setValid(false);
        }
    }, [startDate]);

    const handleStatmentChange = (event) => {
        let statementType = event.target.value;
        setStatementType(statementType);
        setData([]);
    };


    const getAllInvoiceSettings = () => {
        showError('');
        const response = api.get('invoiceSettings');
        response.then(res => {
            setInvoiceSetting(res[0]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No InvoiceSettings Found');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });
        return response;
    }

    const onLoad = () => {
        setLoading(true);
        Promise.all([getAllInvoiceSettings()]).finally(() => {
            setLoading(false);
        });
    }

    useEffect(onLoad, []);

    const generateReport = function () {
        showError('');
        setLoading(true);
        setPopUpLoading(true)
        const payload = { 
            date: startDate,
        };

        let apiName = "reports/customer-bill-balance-report";
        if (statementType === 2) {  
            apiName = "reports/vendor-bill-balance-report";
        }
        const response = api.post(apiName, payload);
        
        response.then(res => {
            setData(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            setPopUpLoading(false)
        });

    };




    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });


    const componentRef = useRef();
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
    });


    return <div className={classes.root}>
        <PageHeader
            actionsInFilterPanel
            title="Bill Balance Report"
            actions={[
                { label: 'Generate', icon: <AssessmentIcon />, onClick: generateReport, variant: 'contained', color: 'primary', disabled: !valid },
                { label: 'Download PDF', icon: <PictureAsPdfIcon />, onClick: generatePDF, variant: 'outlined', color: 'primary', disabled: !valid || data.length < 1 },
                { label: 'Download Excel', icon: <GetAppIcon />, onClick: () => generateExcel(statementType === 1 ? tableHeader : tableHeaderForVendor, data), variant: 'outlined', color: 'primary', disabled: !valid || data.length < 1 },
            ]}
            filters={
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <FormControl style={{minWidth: "160px"}}>
                        <InputLabel id="statementType-select-outlined-label">
                            Type
                        </InputLabel>
                        <Select
                            label="Type"
                            labelId='statementType-select-outlined-label'
                            id="statementType-select"
                            value={statementType}
                            onChange={handleStatmentChange}
                            name="personId"
                        >
                            <MenuItem key={0} value={1}>Customer</MenuItem>
                            <MenuItem key={1} value={2}>Vendor</MenuItem>
                        </Select>
                    </FormControl>
                    <KeyboardDatePicker
                        margin="none"
                        autoOk
                        variant="inline"
                        inputVariant='outlined'
                        label="Until"
                        format="dd/MM/yyyy"
                        size="small"
                        value={startDate}
                        onChange={(date) => setStartDate(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            }
        />
        <div className={classes.content}>
        {loading ?
            <div className={classes.progressContainer}>
                <CircularProgress className={classes.progressBar} />
            </div>
            :
            <div id="vendor-invoice" ref={componentRef} style={{ paddingTop: '35px' }}>
                <div className="invoice-box" style={{
                    backgroundColor: '#ffffff',
                    fontFamily: 'Montserrat,Roboto,sans-serif',
                    color:'#263238'
                }}>
                    <table cellPadding="0" cellSpacing="0">
                        <tbody>
                            <tr >
                                <td>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ width: "40%" }}><img src={invoiceSetting.companyLogo}
                                                                    style={{ //width: '50%', 
                                                                        maxWidth: '130px'
                                                                    }}
                                                                    alt="company logo"></img><br /><br />
                                                                </td>
                                                                <td style={{ width: "50%", fontSize: "13px" }}>
                                                                    <p style={{ fontSize: "14px", fontWeight: 'bolder' }}>
                                                                        {invoiceSetting.companyName}</p>
                                                                    <p style={{ whiteSpace: 'pre-wrap' }}
                                                                    // className="show-white-space"
                                                                    >{invoiceSetting.address}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td style={{ textAlign: "right" }}>
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: '600', fontSize: '23px' }} colSpan="2">
                                                                      { statementType === 1 ? "Customer" : statementType === 2 ? "Vendor" : ""} Bill Balance Report<br />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                </td>
                                                <td style={{ textAlign: "right", width: "50%" }}>
                                                    <table style={{}}>
                                                        <thead>
                                                            <tr>
                                                                {/* <td style={{ textAlign: "right" }}>
                                                                    Date
                                                                </td> */}
                                                                <td style={{ textAlign: "right" }}>
                                                                    {moment(startDate).format('MMM Do YYYY')}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="1" >
                                                                    <Divider />
                                                                    <br />
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ minHeight: "450px" }}>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell style={{textAlign:'center'}}>  { statementType === 1 ? "Customer" : statementType === 2 ? "Vendor" : ""} Name</StyledTableCell>
                                                    <StyledTableCell style={{textAlign:'center'}}>Bill Balance</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            {popUploading ?
                                            <div className={classes.progressContainerA}>
                                                <CircularProgress className={classes.progressBar} />
                                            </div>
                                            :
                                            <TableBody>
                                                { statementType === 1 ?data.map((sale,index) => (
                                                    <StyledTableRow key={index}>
                                                        <StyledTableCell className={
                                        sale.customerName === "Total"  
                                        ? classes.boldedText : undefined
                                        }  style={{textAlign:'center'}}
                                                       align="left">
                                                         {sale.customerName}
                                                        </StyledTableCell>
                                                        <StyledTableCell className={
                                                            sale.customerName === "Total"  
                                                            ? classes.boldedText : undefined
                                                        } style={{textAlign:'center'}}
                                                       align="left">
                                                            {(sale.billBalance).toLocaleString(user.locales,amountObj)}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))
                                                :
                                                data.map((purchase,index) => (
                                                    <StyledTableRow key={index}>
                                                        <StyledTableCell className={
                                                        purchase.vendorName === "Total"  
                                                        ? classes.boldedText : undefined
                                                        }  style={{textAlign:'center'}}
                                                                    align="left">
                                                                        {purchase.vendorName}
                                                                        </StyledTableCell>
                                                                        <StyledTableCell className={
                                                                            purchase.vendorName === "Total"  
                                                                            ? classes.boldedText : undefined
                                                                        } style={{textAlign:'center'}}
                                                                    align="left">
                                                                            {(purchase.billBalance).toLocaleString(user.locales,amountObj)}
                                                                        </StyledTableCell>

                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                            </TableBody>
                                            }
                                        </Table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        }
        </div>
    </div>
}

export default BillBalanceReport;